import { render, staticRenderFns } from "./JudgeWriteModal.vue?vue&type=template&id=8a6fda7e&scoped=true&"
import script from "./JudgeWriteModal.vue?vue&type=script&lang=js&"
export * from "./JudgeWriteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fda7e",
  null
  
)

export default component.exports